export default {
    data() {
        return {
            donationType: '',
            visibleTotals: {
                payOnline: [
                    'pay_at_pickup',
                    'pay_online',
                    'pay_online_with_donation',
                    'pay_online_without_extras',
                    'insurance_online',
                    'extras_online',
                    'extras_paid',
                    'green_heart_donation',
                    'refundshield_difference',
                    'total',
                ],
                payOnlineUS: ['total', 'base_rental', 'extras_on_arrival', 'extras_online', 'green_heart_donation', 'refundshield_difference', 'upgrades', 'total_fees'],
                payOnArrival: [
                    'pay_online',
                    'pay_online_without_extras',
                    'insurance_online',
                    'green_heart_donation',
                    'pay_on_arrival',
                    'pay_on_arrival_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'total',
                ],
                prepaidToPayOnArrival: ['pay_at_pickup', 'green_heart_donation', 'pay_on_arrival', 'pay_on_arrival_without_extras', 'insurance_on_arrival', 'extras_on_arrival', 'total'],
                editingExcludes: ['green_heart_donation'],
            },
        };
    },

    computed: Object.assign({
        location() {
            return typeof this.userLocation !== 'undefined' && (Object.keys(this.userLocation).length > 0 ? this.userLocation.countryCode : 'GB');
        },
        listType() {
            const listTypeByLocation = (this.location === 'US' || this.totals.base_rental !== 0) && this.quote?.us_location ? 'payOnlineUS' : 'payOnline';

            if (this.quote.is_poa_only) {
                return 'payOnArrival';
            }

            if (this.quote.is_poa && !this.globals.isUsavePPAndPoaJourney(this.quote)) {
                return 'prepaidToPayOnArrival';
            }

            return listTypeByLocation;
        },
        sortedTotals() {
            const ordered = {};

            let totals = this.totals;

            // If there's a modification we need to rename the "Extras Pay Now" label to "Extras Paid" and use the modification extras prepay total
            // as the value for "Extras Pay Now"
            if (typeof this.modification !== 'undefined') {
                totals = {
                    ...totals,
                    extras_paid: this.totals.extras_online,
                };

                if (this.modification?.status === 'checked') {
                    totals = Object.assign({}, totals, {
                        extras_online: this.modification.extras_prepay_to_display || 0,
                    });

                    if (this.modification.refundshield_price_to_display > 0) {
                        totals = Object.assign({}, totals, {
                            refundshield_difference: this.modification.refundshield_price_to_display,
                        });
                    }
                } else {
                    // If there's modification and it's not checked, remove the extras_online total, as it means that all the selected extras have been paid already
                    delete totals.extras_online;
                }

                // If the rental price (totals.pay_online_without_extras) is less than the modification vehicle price, we need to display the modification vehicle price as the rental price.
                const modificationVehiclePrice = this.modification?.vehicle_total || 0;
                let modificationVehicleBaseRental = this.lastModification?.vehicle_total || 0;
                let rentalPrice = totals.pay_online_without_extras || 0;

                if (this.lastModification?.vehicle_for_price?.data?.charge_totals?.total_fees > 0) {
                    modificationVehicleBaseRental -= this.lastModification.vehicle_for_price.data.charge_totals.total_fees;
                }

                if (!isNaN(modificationVehicleBaseRental) && modificationVehicleBaseRental > 0) {
                    rentalPrice -= this.selectedVehicle?.charge_totals?.total_fees || 0;
                } else if (!this.lastModification?.vehicle_for_price && this.bookingState?.id && this.bookingState?.id > 0) {
                    // If there are no modifications yet, but there's a booking, we may be in the modifications page, so we also need to deduct the fees of the selected vehicle in the modification page from the rental price.
                    rentalPrice -= this.selectedVehicle?.charge_totals?.total_fees || 0;
                }

                // If modificationVehicleBaseRental is NaN, it means that the vehicle total is 0, so we can set the modificationVehicleBaseRental to 0 as well
                if (isNaN(modificationVehicleBaseRental)) {
                    modificationVehicleBaseRental = 0;
                }

                totals = Object.assign({}, totals, {
                    vehicle_price: Math.max(modificationVehiclePrice, totals.vehicle_price || 0),
                    pay_online_without_extras: Math.max(modificationVehiclePrice, rentalPrice),
                    base_rental: Math.max(modificationVehicleBaseRental, rentalPrice),
                });
            }

            Object.keys(totals)
                .sort((a, b) => {
                    return this.visibleTotals[this.listType].indexOf(a) - this.visibleTotals[this.listType].indexOf(b);
                })
                .forEach((key) => {
                    ordered[key] = totals[key];
                });

            return ordered;
        },
        prePaid() {
            return this.quote.payment_type === 'PP';
        },
        priceIsConverted() {
            return this.quote.currency !== this.selectedCurrency.code;
        },
    }),

    methods: {
        displayTotal(key, modifying) {
            let display =
                this.visibleTotals[this.listType].includes(key) &&
                (this.totals[key] !== 0 ||
                    (modifying && !this.visibleTotals['editingExcludes'].includes(key)) ||
                    ((key == 'extras_online' || key == 'extras_on_arrival') && this.selectedExtras?.length > 0));

            return display;
        },
        isSubItem(key) {
            if (this.prePaid) {
                // return ['insurance_online', 'extras_online', 'pay_online_without_extras'].indexOf(key) > -1;
                return ['insurance_online', 'extras_online'].indexOf(key) > -1;
            }

            return (
                [
                    'insurance_online',
                    'extras_online',
                    // 'pay_online_without_extras',
                    'insurance_on_arrival',
                    'extras_on_arrival',
                    'pay_on_arrival_without_extras',
                ].indexOf(key) > -1
            );
        },
    },
};
